export default function initSinglePolitiker() {
    const el = document.querySelector('.spoln');
    if (!el) {
        return;
    }

    const storyInnerEl = el.querySelector('.spoln-storyInner');
    if (!storyInnerEl) {
        return;
    }

    if (storyInnerEl.innerText.length > 200) {
        attachReadMore();
    }

    function attachReadMore() {
        const btnEl = Object.assign(document.createElement('button'), {
            innerText: `Läs mer`,
            className: `spoln-readMore`,
            title: `Visa alla text`,
        });

        minimize();
        window.addEventListener('resize', recalc);
        window.addEventListener('orientationchange', recalc);
        storyInnerEl.classList.add('is--minimized');

        btnEl.addEventListener('click', toggle);
        storyInnerEl.appendChild(btnEl);

        function recalc() {
            if (isMinimized()) {
                storyInnerEl.style.height = `10em`;
            } else {
                storyInnerEl.style.height = `${storyInnerEl.scrollHeight + btnEl.offsetHeight * 0.75}px`;
            }
        }

        function isMinimized() {
            return storyInnerEl.classList.contains('is--minimized');
        }

        function toggle() {
            isMinimized() ? maximize() : minimize();
        }

        function maximize() {
            btnEl.classList.add('is--less');
            storyInnerEl.classList.remove('is--minimized');
            recalc();
            changeButtonText('mindre');
        }

        function minimize() {
            btnEl.classList.remove('is--less');
            storyInnerEl.classList.add('is--minimized');
            recalc();
            changeButtonText('mer');
        }

        async function changeButtonText(text) {
            // Why not?
            const letters = text.split('');
            const left = [];
            btnEl.textContent = 'Läs ';
            while (left.length !== letters.length) {
                for (let letter of letters) {
                    await new Promise(resolve => {
                        setTimeout(() => {
                            btnEl.textContent = btnEl.textContent + letter;
                            resolve();
                        }, 50);
                    });
                    left.push(letter);
                }
            }
        }
    }
}
